import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { GOOGLE_AUTH_TRANSACTION_ACTION_TYPE } from "./google-auth-transaction.action";
import { GoogleAuthTransactionState } from "./google-auth-transaction.model";

const INITIAL_STATE: GoogleAuthTransactionState = {};

export function googleAuthTransactionReducer(
	state = INITIAL_STATE,
	action: ActionWithPayload
): GoogleAuthTransactionState {
	switch (action.type) {
		case GOOGLE_AUTH_TRANSACTION_ACTION_TYPE.setOpenIdConnectUrlSuccess: {
			return updateState(state, {
				openIdConnectUrl: action.payload,
			});
		}
		case GOOGLE_AUTH_TRANSACTION_ACTION_TYPE.reset: {
			return INITIAL_STATE;
		}
		default:
			return state;
	}
}
